import React, { useEffect, useState } from "react";
import Button from "../common/CommonButton/Button";
import { formatImageUrl } from "../../../helper/helper";
import { Col, Row } from "react-bootstrap";
import DuncanTaylorVideo from "../common/duncanTaylorVideo";
import Link from "next/link";

const NewOctaveJourneySection = (props: any) => {
  const [isMobile, setIsMobile] = useState(false);
  let [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  let logoImage: any = formatImageUrl(
    props?.data?.media?.data?.attributes?.url
  );
  let logoImageMobile: any = formatImageUrl(
    props?.data?.media_mobile?.data?.attributes?.url
  );
  // let mediaImage: any = "/octave-collection-new/journey_image_new.png";
  let mediaImage: any = props?.data?.media?.data?.attributes?.url;
  let mediaImageMobile: any = props?.data?.media?.data?.attributes?.url;
  return (
    <section className="octave_collection_new_details" id="journery-section">
      <h5 className="new_octave_collection_title new_octave_title_margin_bottom">
        {props?.data?.title}
      </h5>
      <div className="collection_container">
        <Row>
          <Col sm={12} md={12} lg={6}>
            <div className="octave_collection_new_details_text octave_journey_margin_bottom">
              <div className="inner_div">
                {/* <h2 className={"journey_title"}>{props?.data?.title}</h2> */}
                {/* {props?.data?.media?.data && (
                  <img src={isMobile ? logoImageMobile : logoImage} alt={`bottle`} className="octave_logo" />
                )} */}

                <p className={"description"}>{props?.data?.description}</p>
                <p className={"description mb-0"}>
                  {props?.data?.description_bottom}
                </p>

                <ul className="octave_dis_list">
                  {props?.data?.description_list?.map((list: any, key: any) => {
                    return <li>{list?.children[0].text}</li>;
                  })}
                </ul>

                {props?.data?.cta?.link && (
                  <>
                    <Link
                      href={props?.data?.cta?.link}
                      target={props?.data?.cta?.open_in_new_tab ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <button className="learnMore">
                        {props?.data?.cta?.title}
                      </button>
                    </Link>
                  </>
                )}
                {/* <button
                  className="learnMoreSecondary"
                  onClick={() => {
                    const section = document.getElementById("cask-section");
                    if (section) {
                      section.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
                >
                  BOTTLE AN OCTAVE CASK
                </button> */}
              </div>
            </div>
          </Col>
          <Col sm={12} md={12} lg={6}>
            <div className="octave_collection_new_text_outer_div">
              {isClicked ? (
                <DuncanTaylorVideo
                  data={props?.data?.video_link}
                  classforvideo="newoctave_collection_secondfold_videoplaycontainer"
                />
              ) : (
                <div className="thumbnail_wrapper thumbnail_wrapper_jounerysection">
                  <img
                    src={isMobile ? mediaImageMobile : mediaImage}
                    alt={`logo`}
                    className="octave_logo thumbnail_image"
                  />

                  <div
                    onClick={() => setIsClicked(true)}
                    className="thumbnail_btn"
                  >
                    <img
                      src={"/octave-collection-new/youtube.svg"}
                      alt={`thumnail`}
                      className=""
                    />
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default NewOctaveJourneySection;
